<template>
  <div>
    <form
      class="text-xs flex space-y-2 md:space-y-0 md:items-end md:flex-row md:space-x-2 items-start flex-col "
      @submit.prevent="saveForm()"
    >
      <template v-if="trx.gateway_id == 1">
        <div>
          <label>Hesap Bilgileri </label>
          <textarea
            type="text"
            class="uk-textarea w-full"
            v-model="form.delivery_iban"
          ></textarea>
        </div>

        <div class="md:self-end">
          <SaveButton title="Kaydet" />
        </div>
      </template>
      <template v-if="trx.gateway_id == 2"
        >Kredi Kartı ödemesi bekleniyor</template
      >
      <template v-if="trx.gateway_id == 5">
        <div>
          <label>Cüzdan Adresi</label>
          <textarea
            type="text"
            class="uk-input w-full"
            v-model="form.delivery_iban"
          ></textarea>
        </div>
        <div class="md:self-end">
          <SaveButton title="Kaydet" />
        </div>
      </template>
    </form>
    <span v-if="ibanError" style="color: red;" class="  text-xs">
      {{ ibanError }}
    </span>
  </div>
</template>
<script>
import http from "../../../services/http";
import EventBus from "../../Ui/EventBus";
import SaveButton from "../../Ui/SaveButton.vue";

export default {
  data() {
    return {
      form: {},
      ibanError: false,
    };
  },
  props: ["trx"],
  methods: {
    saveForm() {
      http.transaction
        .deliveryIban(this.trx.id, this.form)
        .then((resp) => {
          if (resp.data.success) {
            EventBus.$emit("transactionReload", true);
          }
        })
        .catch((msg) => {
          this.$root.errorMessage(msg.response.data);
        });
    },
    validateIban() {
      const isValidIban = this.isValidIban(this.form.delivery_iban);
      if (!isValidIban) {
        this.ibanError = "Geçersiz IBAN numarası";
      } else {
        this.ibanError = "";
      }
    },
    isValidIban(iban) {
      const turkeyIbanRegex = /^TR\d{2}\d{5}[0-9A-Z]{1}[0-9]{16}$/;
      if (iban.length !== 26 || !turkeyIbanRegex.test(iban)) {
        return false;
      }
      return true;
    },
  },
  components: { SaveButton },
};
</script>
